import React from 'react';
import { isEmpty } from 'lodash';
import { handleError } from 'services/ErrorService/ErrorService';
import { formatDate, parseUTCDate } from '../../../../util';
import * as toolSelectors from '../../../../selectors/tools';
import { useSelector } from 'react-redux';
import {
  ResultsColumn,
  ResultsColumnHeader,
  Row,
  HeaderRow,
  SubTitleText,
  Spreadsheet,
  LastItem,
  UppercaseSpan,
  NotLastItem,
  TitleText,
  ColumnTitle,
  TitleRow,
  Column,
} from '../DTInfoWidget.styles';

const DTAmazonOrderDetailsWidget = () => {
  const selectedOrder = useSelector(toolSelectors.getSelectedOrder);
  const refundAmount = useSelector(toolSelectors.getRefundAmount) || 'N/A';
  const orderTotal = useSelector(toolSelectors.getOrderTotal) || 'N/A';
  const currencyCode = useSelector(toolSelectors.getCurrencyCode) || 'N/A';

  // pending or canceled order's Amount, BuyerName, CurrencyCode are undefined, use N/A instead
  const { OrderItems, AmazonOrderId, PurchaseDate, OrderStatus, BuyerName: customerName = 'N/A' } = selectedOrder;
  const orderTitle = !isEmpty(OrderItems) && OrderItems[0].Title;

  // check for undefined values
  const selectedOrderDetails = {
    OrderItems,
    AmazonOrderId,
    PurchaseDate,
    OrderStatus,
    orderTitle,
    refundAmount,
    customerName,
    orderTotal,
  };

  for (const key in selectedOrderDetails) {
    if (!selectedOrderDetails[key]) {
      const errorMessage = `${key} is undefined`;

      return handleError({ customMessage: errorMessage, showPopup: true });
    }
  }

  return (
    <>
      <TitleRow className="fs-block">
        <ColumnTitle>
          <TitleText>ORDER ID: {AmazonOrderId}</TitleText>
        </ColumnTitle>
        <Column>
          <NotLastItem>DATE OF ORDER: {formatDate(parseUTCDate(PurchaseDate))}</NotLastItem>
          <LastItem>
            STATUS: <UppercaseSpan>{OrderStatus}</UppercaseSpan>
          </LastItem>
        </Column>
      </TitleRow>
      <Spreadsheet className="fs-block">
        <SubTitleText>Order Details</SubTitleText>
        <HeaderRow>
          <ResultsColumnHeader>ITEM</ResultsColumnHeader>
          <ResultsColumnHeader>TOTAL PRICE</ResultsColumnHeader>
          <ResultsColumnHeader>REFUND AMOUNT</ResultsColumnHeader>
          <ResultsColumnHeader>CUSTOMER NAME</ResultsColumnHeader>
        </HeaderRow>
        <Row>
          <ResultsColumn>{orderTitle}</ResultsColumn>
          <ResultsColumn>
            {orderTotal} {currencyCode}
          </ResultsColumn>
          <ResultsColumn>
            {refundAmount} {currencyCode}
          </ResultsColumn>
          <ResultsColumn>{customerName}</ResultsColumn>
        </Row>
      </Spreadsheet>
    </>
  );
};
export default DTAmazonOrderDetailsWidget;
